module.exports = __webpack_public_path__ + "static/media/025-teeth.ff62bbd9.svg";